<template>
  <div>
    <div class="nkn-container">
      <div class="nkn-eg-dapp">
        <div class="common-sub-title">{{$t("developer.dapp.title")}}</div>
        <div class="dapp-content">
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-4">
              <div class="dapp-content-detail">
                <dapp-module>
                  <img
                    v-lazy="'/static/img/developer/dApp/dchat.png'"
                    slot="dapp-pic"
                    class="pic-dapp pic-dapp-chat"
                  />
                  <span slot="dapp-title">{{$t("developer.dapp.subtitle6")}}</span>
                  <span slot="dapp-content">{{$t("developer.dapp.subContent6")}}</span>
                  <a
                    slot="dapp-link"
                    :href="$url.DEVELOPER_DAPP.dchatTryit"
                    target="_blank"
                  >{{$t("developer.dapp.subContent6Link1")}}</a>
                  <a
                    slot="dapp-link"
                    :href="$url.DEVELOPER_DAPP.dchatGitlab"
                    target="_blank"
                  >{{$t("developer.dapp.subContent6Link2")}}</a>
                </dapp-module>
              </div>
            </div>

            <div class="col-xs-6 col-sm-6 col-md-4">
              <div class="dapp-content-detail">
                <dapp-module>
                  <img
                    v-lazy="'/static/img/developer/dApp/nsh.png'"
                    slot="dapp-pic"
                    class="pic-dapp-nsh"
                  />
                  <span slot="dapp-title">{{$t("developer.dapp.subtitle15")}}</span>
                  <div slot="dapp-content">{{$t("developer.dapp.subContent15")}}</div>
                  <a
                    v-if="this.$i18n.locale === 'zh'"
                    slot="dapp-link"
                    :href="$url.PRODUCT_LINK.nsh_zh"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                  <a
                    v-else
                    slot="dapp-link"
                    :href="$url.PRODUCT_LINK.nsh"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                  <a
                    slot="dapp-link"
                    :href="$url.PRODUCT_LINK.nsh_github"
                    target="_blank"
                  >{{$t("developer.dapp.subContent3Link2")}}</a>
                </dapp-module>
              </div>
            </div>

            <div class="col-xs-6 col-sm-6 col-md-4">
              <div class="dapp-content-detail">
                <dapp-module>
                  <img
                    v-lazy="'/static/img/developer/dApp/d-ftp.png'"
                    slot="dapp-pic"
                    class="pic-dapp-dftp"
                  />
                  <span slot="dapp-title">{{$t("developer.dapp.subtitle16")}}</span>
                  <div slot="dapp-content">{{$t("developer.dapp.subContent16")}}</div>
                  <a
                    v-if="this.$i18n.locale === 'zh'"
                    slot="dapp-link"
                    :href="$url.PRODUCT_LINK.dftp_zh"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                  <a
                    v-else
                    slot="dapp-link"
                    :href="$url.PRODUCT_LINK.dftp"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                  <a
                    slot="dapp-link"
                    :href="$url.PRODUCT_LINK.dftp_github"
                    target="_blank"
                  >{{$t("developer.dapp.subContent3Link2")}}</a>
                </dapp-module>
              </div>
            </div>

            <div class="col-xs-6 col-sm-6 col-md-4">
              <div class="dapp-content-detail">
                <dapp-module>
                  <img
                    v-lazy="'/static/img/developer/dApp/spacecats.png'"
                    slot="dapp-pic"
                    class="pic-dapp pic-dapp-spacecats"
                  />
                  <span slot="dapp-title">{{$t("developer.dapp.subtitle1")}}</span>
                  <div slot="dapp-content">{{$t("developer.dapp.subContent1")}}</div>
                  <a
                    v-if="lang === 'zh'"
                    slot="dapp-link"
                    :href="$url.DEVELOPER_DAPP.scatsPresentation_ZH"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                  <a
                    v-else
                    slot="dapp-link"
                    :href="$url.DEVELOPER_DAPP.scatsPresentation"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                  <a
                    slot="dapp-link"
                    :href="$url.DEVELOPER_DAPP.scatsDownload"
                    target="_blank"
                  >{{$t("developer.dapp.subContent3Link2")}}</a>
                </dapp-module>
              </div>
            </div>

            <div class="col-xs-6 col-sm-6 col-md-4">
              <div class="dapp-content-detail">
                <dapp-module>
                  <i class="icon-product-iotex" slot="dapp-pic"></i>
                  <span slot="dapp-title">{{$t("developer.dapp.subtitle8")}}</span>
                  <div slot="dapp-content">{{$t("developer.dapp.subContent8")}}</div>
                  <a
                    v-if="lang === 'zh'"
                    slot="dapp-link"
                    :href="$url.DEVELOPER_DAPP.iotexInfo_ZH"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                  <a
                    v-else
                    slot="dapp-link"
                    :href="$url.DEVELOPER_DAPP.iotexInfo"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                </dapp-module>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-4">
              <div class="dapp-content-detail">
                <dapp-module>
                  <img
                    v-lazy="'/static/img/developer/dApp/wallet.png'"
                    slot="dapp-pic"
                    class="pic-dapp pic-dapp-spacecats"
                  />
                  <span slot="dapp-title">{{$t("developer.dapp.subtitle12")}}</span>
                  <div slot="dapp-content">{{$t("developer.dapp.subContent12")}}</div>
                  <a
                    slot="dapp-link"
                    :href="$url.PRODUCT_LINK.wallet"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                </dapp-module>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-4">
              <div class="dapp-content-detail">
                <dapp-module>
                  <img
                    v-lazy="'/static/img/developer/dApp/explorer.png'"
                    slot="dapp-pic"
                    class="pic-dapp pic-dapp-spacecats"
                  />
                  <span slot="dapp-title">{{$t("developer.dapp.subtitle13")}}</span>
                  <div slot="dapp-content">{{$t("developer.dapp.subContent13")}}</div>
                  <a
                    slot="dapp-link"
                    :href="$url.PRODUCT_LINK.nknx_explorer"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                </dapp-module>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-4">
              <div class="dapp-content-detail">
                <dapp-module>
                  <img
                    v-lazy="'/static/img/developer/dApp/nknx_node.png'"
                    slot="dapp-pic"
                    class="pic-dapp pic-dapp-spacecats"
                  />
                  <span slot="dapp-title">{{$t("developer.dapp.subtitle14")}}</span>
                  <div slot="dapp-content">{{$t("developer.dapp.subContent14")}}</div>
                  <a
                    slot="dapp-link"
                    :href="$url.PRODUCT_LINK.nknx"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                </dapp-module>
              </div>
            </div>
            <!--<div class="col-xs-6 col-sm-6 col-md-4">
              <div class="dapp-content-detail">
                <dapp-module>
                  <img v-lazy="'/static/img/developer/dApp/chat.png'" slot="dapp-pic" class="pic-dapp pic-dapp-chat">
                  <span slot="dapp-title">{{$t("developer.dapp.subtitle2")}}</span>
                  <span slot="dapp-content">{{$t("developer.dapp.subContent2")}}</span>
                  <a slot="dapp-link" :href="$url.DEVELOPER_DAPP.nknchat" target="_blank">{{$t("developer.dapp.subContent2Link1")}}</a>
                </dapp-module>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="nkn-container">
      <div class="nkn-eg-dapp">
        <div class="common-sub-title">{{$t("developer.dapp.title2")}}</div>
        <div class="dapp-content">
          <div class="row">
            <!--<div class="col-xs-6 col-sm-6 col-md-4">
              <div class="dapp-content-detail">
                <dapp-module>
                  <img v-lazy="'/static/img/developer/dApp/pubsub.png'" slot="dapp-pic" class="pic-dapp pic-dapp-nknx">
                  <span slot="dapp-title">{{$t("developer.dapp.subtitle9")}}</span>
                  <div slot="dapp-content">{{$t("developer.dapp.subContent9")}}</div>
                  <a slot="dapp-link" href="https://dataRide.io" target="_blank">https://dataRide.io</a>
                  <a v-if="lang === 'zh'" slot="dapp-link" :href="$url.DEVELOPER_DAPP.pubSubInfo_ZH" target="_blank">{{$t("developer.dapp.subContent5Link1")}}</a>
                  <a v-else slot="dapp-link" :href="$url.DEVELOPER_DAPP.pubSubInfo" target="_blank">{{$t("developer.dapp.subContent5Link1")}}</a>

                </dapp-module>
              </div>
            </div>-->
            <div class="col-xs-6 col-sm-6 col-md-4">
              <div class="dapp-content-detail">
                <dapp-module>
                  <img
                    v-lazy="'/static/img/developer/dApp/ncdn.png'"
                    slot="dapp-pic"
                    class="pic-dapp pic-dapp-chat"
                  />
                  <span slot="dapp-title">{{$t("developer.dapp.subtitle7")}}</span>
                  <span slot="dapp-content">{{$t("developer.dapp.subContent7")}}</span>
                  <!--<a slot="dapp-link" :href="$url.DEVELOPER_DAPP.dchatTryit" target="_blank">{{$t("developer.dapp.subContent6Link1")}}</a>-->
                  <a slot="dapp-link" href="https://ncdn.io" target="_blank">https://ncdn.io</a>
                  <a
                    v-if="lang === 'zh'"
                    slot="dapp-link"
                    :href="$url.PRODUCT_LINK.ncdn_zh"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                  <a
                    v-else
                    slot="dapp-link"
                    :href="$url.PRODUCT_LINK.ncdn"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                </dapp-module>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-4">
              <div class="dapp-content-detail">
                <dapp-module>
                  <img
                    v-lazy="'/static/img/developer/dApp/Tuna.png'"
                    slot="dapp-pic"
                    class="pic-dapp pic-dapp-nknx"
                  />
                  <span slot="dapp-title">{{$t("developer.dapp.subtitle10")}}</span>
                  <span slot="dapp-content">{{$t("developer.dapp.subContent10")}}</span>
                  <a
                    v-if="lang === 'zh'"
                    slot="dapp-link"
                    :href="$url.PRODUCT_LINK.tuna_ZH"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                  <a
                    v-else
                    slot="dapp-link"
                    :href="$url.PRODUCT_LINK.tuna"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                  <a
                    slot="dapp-link"
                    :href="$url.DEVELOPER_RESOURCE.tuna"
                    target="_blank"
                  >{{$t("developer.dapp.subContent3Link2")}}</a>
                </dapp-module>
              </div>
            </div>

            <div class="col-xs-6 col-sm-6 col-md-4">
              <div class="dapp-content-detail">
                <dapp-module>
                  <img
                    v-lazy="'/static/img/developer/dApp/NanoPay.png'"
                    slot="dapp-pic"
                    class="pic-dapp pic-dapp-spacecats"
                  />
                  <span slot="dapp-title">{{$t("developer.dapp.subtitle11")}}</span>
                  <div slot="dapp-content">{{$t("developer.dapp.subContent11")}}</div>
                  <a
                    slot="dapp-link"
                    :href="$url.DEVELOPER_DAPP.nanopay"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                </dapp-module>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-4">
              <div class="dapp-content-detail">
                <dapp-module>
                  <img
                    v-lazy="'/static/img/developer/dApp/multi-client.png'"
                    slot="dapp-pic"
                    class="pic-dapp-multi-client"
                  />
                  <span slot="dapp-title">{{$t("developer.dapp.subtitle17")}}</span>
                  <div slot="dapp-content">{{$t("developer.dapp.subContent17")}}</div>
                  <a
                    v-if="this.$i18n.locale === 'zh'"
                    slot="dapp-link"
                    :href="$url.DEVELOPER_DAPP.multiClient_zh"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                  <a
                    v-else
                    slot="dapp-link"
                    :href="$url.DEVELOPER_DAPP.multiClient"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                  <a
                    slot="dapp-link"
                    :href="$url.DEVELOPER_DAPP.multiClient_github"
                    target="_blank"
                  >{{$t("developer.dapp.subContent3Link2")}}</a>
                </dapp-module>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-4">
              <div class="dapp-content-detail">
                <dapp-module>
                  <img
                    v-lazy="'/static/img/developer/dApp/pubsub.png'"
                    slot="dapp-pic"
                    class="pic-dapp-multi-client"
                  />
                  <span slot="dapp-title">{{$t("developer.dapp.subtitle18")}}</span>
                  <div slot="dapp-content">{{$t("developer.dapp.subContent18")}}</div>
                  <a
                    v-if="this.$i18n.locale === 'zh'"
                    slot="dapp-link"
                    href="https://dataride.nkn.org/zh/"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                  <a
                    v-else
                    slot="dapp-link"
                    href="https://dataride.nkn.org"
                    target="_blank"
                  >{{$t("developer.dapp.subContent5Link1")}}</a>
                </dapp-module>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nkn-container">
      <div class="nkn-eg-dapp">
        <div class="bounty-content">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div class="common-sub-title">{{$t("developer.bounty.title")}}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-4">
              <div class="dapp-content-detail">
                <dapp-module>
                  <img
                    v-lazy="'/static/img/developer/dApp/cash.png'"
                    slot="dapp-pic"
                    class="pic-dapp pic-dapp-cash cash-pic-style"
                  />
                  <span slot="dapp-title">{{$t("developer.bounty.subtitle1")}}</span>
                  <span slot="dapp-content">{{$t("developer.bounty.subContent1")}}</span>
                  <a
                    slot="dapp-link"
                    :href="$url.DEVELOPER_RESOURCE.clientcode"
                    target="_blank"
                  >{{$t("developer.bounty.subContent1Link1")}}</a>
                </dapp-module>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DappModule from "@/components/developer/plugins/dAppModule";

export default {
  computed: {
    ...mapState({
      lang: state => state.lang.lang
    })
  },
  components: {
    DappModule
  }
};
</script>

<style lang="scss" scoped>
.nkn-container:nth-child(even) {
  background-color: #f9faff;
}
.icon-product-Telco,
.icon-product-iotex,
.icon-product-Iot {
  width: 80px;
  height: 80px;
}
.dapp-content {
  .row {
    display: flex;
    flex-wrap: wrap;
  }
}

.nkn-eg-dapp {
  @include common-inner();

  .bounty-content {
    margin-top: 3.5rem;
    @media screen and (max-width: 768px) {
      margin-top: 60px;
    }
  }

  .pic-dapp {
    width: 80px;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/developer/nkndApp.vue